const ro = {
  header: {
    about: "DESPRE NOI",
    artist: "ARTIST",
    services: "SERVICII",
    contact: "CONTACTEAZĂ-NE",
    whatsapp: "WHATSAPP"
  },
  home: {
    welcomeTitle: "Kellink Tattoo",
    welcomeText: "Bine ați venit în studioul nostru unde pasiunea întâlnește precizia",
    browserUnsupported: "Browserul dvs. nu suportă etichetele video."
  },
  about: {
    title: "Noi suntem",
    highlight: "Kellink Tattoo",
    description: "Bine ați venit la Kellink Tattoo! Suntem artiști pasionați dedicați creării de tatuaje unice și semnificative care spun povestea ta. Cu ani de experiență în diverse stiluri și tehnici, ne mândrim cu oferirea unei artizanalități excepționale într-un mediu curat și profesionist. Angajamentul nostru pentru calitate și atenția la detalii asigură că fiecare tatuaj pe care îl creăm este o capodoperă care va dura o viață."
  },
  artist: {
    sectionTitle: "Artist",
    name: "Conlitchenko Gabriel",
    title: "Artist Profesionist de Tatuaje",
    bio: "Cu o pasiune pentru crearea de tatuaje frumoase și semnificative, mă specializez în crearea de modele care spun povestea ta personală. Abordarea mea combină viziunea artistică cu precizia tehnică pentru a crea tatuaje care rezistă testului timpului.",
    specialtiesTitle: "Specialități",
    specialties: ["Realist", "Alb-Negru", "Tradițional", "Modele Personalizate"],
    experienceTitle: "Experiență",
    experienceText: "Peste 10 ani de experiență profesională în tatuaje, perfecționând continuu tehnicile și explorând noi direcții artistice.",
    ctaButton: "PROGRAMEAZĂ O CONSULTAȚIE"
  },
  gallery: {
    title: "Galeria Noastră",
    subtitle: "Vizualizați cele mai recente creații și stiluri artistice",
    viewButton: "VIZUALIZARE COMPLETĂ",
    backButton: "ÎNAPOI",
    navigationPrev: "Anterior",
    navigationNext: "Următor",
    closeModal: "Închide",
    visitLink: "Vizitează pagina de design",
    instagram: "Urmărește pe Instagram",
    facebook: "Apreciază pe Facebook",
    zoomImage: "Mărește imaginea"
  },
  services: {
    title: "Serviciile Noastre",
    intro: "Oferim o gamă completă de servicii de tatuaje pentru a se potrivi fiecărui stil și preferință. Artiștii noștri experimentați se specializează în diverse tehnici și modele, asigurându-vă că primiți lucrări de cea mai înaltă calitate care exprimă perfect viziunea dumneavoastră.",
    serviceCards: [
      {
        title: "Design Personalizat de Tatuaje",
        description: "Modele de tatuaje unice, personalizate, create special pentru tine. Preluăm ideile tale și le transformăm în opere originale care reflectă personalitatea și stilul tău. Fiecare design este realizat cu atenție la detalii și excelență artistică."
      },
      {
        title: "Tradițional & Neo-Tradițional",
        description: "Linii îndrăznețe, culori vibrante și imagini atemporale caracterizează stilurile noastre tradiționale de tatuaje. De la designuri clasice de marinar până la interpretări moderne, artiștii noștri sunt pricepuți în crearea de piese tradiționale frumoase și durabile."
      },
      {
        title: "Tatuaje Realiste & Portrete",
        description: "Tatuaje realiste care surprind detalii și dimensiuni extraordinare. Specialiștii noștri în realism creează portrete uimitoare, scene din natură și imagini fotorealiste care par că prind viață pe pielea ta."
      },
      {
        title: "Acoperiri & Retușări",
        description: "Transformă tatuajele vechi, decolorate sau nedorite în modele noi și frumoase. Artiștii noștri sunt experți în crearea de tatuaje de acoperire care ascund complet lucrările anterioare, creând ceva nou pe care îl vei iubi pentru ani de zile."
      }
    ]
  },
  contact: {
    subtitle: "DOREȘTI O DISCUȚIE? CONTACTEAZĂ-NE.",
    title: "Să vorbim, să ne întâlnim, să colaborăm.",
    formTitle: "Contactează-ne.",
    formLabels: {
      name: "Nume",
      phone: "Telefon",
      email: "Email",
      instagram: "Instagram",
      message: "Mesaj"
    },
    submitButton: "TRIMITE"
  },
  footer: {
    companyName: "Kellink Tattoo S.R.L.",
    navigation: "Navigare",
    contact: "Contact",
    followUs: "Urmărește-ne",
    copyright: "Toate drepturile rezervate.",
    links: {
      privacy: "Politica de Confidențialitate",
      terms: "Termeni și Condiții"
    }
  },
  language: {
    en: "Engleză",
    ro: "Română"
  }
};

export default ro; 